// extracted by mini-css-extract-plugin
module.exports = {"root":"ReCaptchaLabel_root__aw1wa","inFooter":"ReCaptchaLabel_inFooter__tSO_Z"};